import axios from "@/libs/api.request.js";
import { getEnv } from "./heziShare";
import { getBoxPrefix } from './btBoxActivity'


/**
 * 多域名信息
 */
export const getWxBoxHost = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/domain/config`,
    data,
  });
}

// 账号注销-获取用户状态
export const getWxUserStatusV2Api = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-user/user/status/v2`,
    data,
    requireToken: true,
    requireSign: true,
  });

// 账号注销-发送短信验证码
export const sendWxUserCloseSmsApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-user/user/sendCloseMobileCode`,
    data,
    requireToken: true,
    unHint: true,
  });

// 账号注销-查询用户是否实名
export const getWxUserRealNameStatusApi = (data = {}) =>
  axios.request({
    url: `${getEnv()}/wx-box-user/user/real/name/status`,
    data,
    requireToken: true,
    unHint: true,
  });

// 账号注销-提交新版注销申请
export const closeWxUserApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-user/user/close/apply`,
    data,
    requireToken: true,
    unHint: true,
  });

/**
 * 648拉新拉收活动-游戏会场列表
 * @param {*} data
 * @returns
 */
export const getGamePlaceListApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-game/pull-the-new/game/places/mainList`,
    data,
    requireToken: true,
  });

/**
 * 648拉新拉收活动
 * @param {*} data
 * @returns
 */
export const getWelfareApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-game/pull-the-new/game/receive-welfare`,
    data,
    requireToken: true,
  });

/**
 * 玩心盒子周活打卡活动-主会场信息
 * @param {*} data id：会场活动id 非必传字段
 * @returns
 */
export const getWeekSignInActiveListApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/active/weekly-clock/places/mainList`,
    data,
    requireToken: true,
  });

/**
 * 玩心盒子周活打卡活动-获取游戏会场列表
 * @returns
 */
export const getWeekSignInActivePlacesApi = () =>
  axios.request({
    url: `${getEnv()}/wx-box-active/active/weekly-clock/places`,
    requireToken: true,
  });

/**
 * 玩心盒子周活打卡活动-用户打卡
 * @param {*} data id：会场活动id
 * @returns
 */
export const setWeekSignInActiveApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/active/weekly-clock/places/signIn`,
    data,
    requireToken: true,
  });

/**
 * 玩心盒子周活打卡活动-礼包领取
 * @param {*} data id：会场活动id giftId：礼包id
 * @returns
 */
export const getWeekSignInActiveGiftApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/active/weekly-clock/gift-receive`,
    data,
    requireToken: true,
    unHint: true,
  });

/**
 * 玩心盒子648活动-在玩游戏
 * @param {*} data activeId：活动id
 * @returns
 */
export const getPlayGamePlaceListApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-game/pull-the-new/game/playingList`,
    data,
    requireToken: true,
  });

/**
 * 获取自定义图文配置
 * @param {*} data
 * @returns
 */
export const getWxTemplateApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/active/selfConfigDetail`,
    data,
    requireToken: true,
  });

/**
 * 获取自定义图文配置
 * @param {*} data
 * @returns
 */
export const sendDeviceCodeApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/fission/deviceCodeReport`,
    data,
    headers: { "Content-Type": "multipart/form-data" },
  });

/**
 * 优算云云挂机引流领取
 * @param {*} data
 * @returns
 */
export const drawCloudReward = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/active/cloud/draw`,
    data,
    requireToken: true,
    unHint: true,
  });

/**
 * 累充活动首页
 * @param {*} data
 * @returns
 */
export const getWxPayAmountActivityConfigApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/payActivity/getHomeList`,
    data,
    requireToken: true,
  });

/**
 * 累充活动礼包列表
 * @param {*} data
 * @returns
 */
export const getWxPayAmountActivityGiftsApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/payActivity/getGameGiftList`,
    data,
    requireToken: true,
  });

/**
 * 累充活动领取礼包
 * @param {*} data
 * @returns
 */
export const receiveWxPayAmountActivityGiftApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/payActivity/drawGift`,
    data,
    requireToken: true,
    unHint: true,
  });

/**
 * 礼包周周领-会场
 * @param {*} data
 * @returns
 */
export const weekGiftPlacesApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/weekTo/weekToList`,
    data,
    requireToken: true,
  });

/**
 * 礼包周周领-礼包列表
 * @param {*} data
 * @returns
 */
export const weekGiftListApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/weekTo/weekToGiftList`,
    data,
    requireToken: true,
  });

/**
 * 礼包周周领-打卡
 * @param {*} data
 * @returns
 */
export const weekGiftClickApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/weekTo/punchCard`,
    data,
    requireToken: true,
  });

/**
 * 礼包周周领-领取
 * @param {*} data
 * @returns
 */
export const getWeekGiftApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/weekTo/drawGift`,
    data,
    requireToken: true,
  });

// 玩心双重福利节-游戏会场
export const getDoubleWelfarePlaceApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-game/double-welfare/mainList`,
    data,
    requireToken: true,
  });
// 玩心双重福利节-游戏会场
export const getDoubleWelfareApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-game/double-welfare/list`,
    data,
    requireToken: true,
  });
// 玩心双重福利节-游戏会场
export const receiveDoubleWelfareApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-game/double-welfare/receive`,
    data,
    requireToken: true,
  });

// 夺宝活动-活动信息
export const getWinTreasureInfoApi = () =>
  axios.request({
    url: `${getEnv()}/wx-box-active/seizeTreasures/info`,
    requireToken: true,
  });

// 夺宝活动-游戏会场
export const getWinTreasurePlaceApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/seizeTreasures/placeList`,
    data,
    requireToken: true,
  });


// 夺宝活动-游戏会场-详情
export const getWinTreasureDetailApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/seizeTreasures/place/detail`,
    data,
    requireToken: true,
  });

// 夺宝活动-游戏会场-排名
export const getWinTreasureRankApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/seizeTreasures/rank`,
    data,
    requireToken: true,
  });

// 夺宝活动-参与夺宝活动
export const signInWinTreasureApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/seizeTreasures/join`,
    data,
    requireToken: true,
  });

// 活动会场列表
export const getPlaceListApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/places`, data, requireToken: true});
// 抽奖活动导航栏信息
export const getPlaceBannerApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/draw/banner`, data, requireToken: true});
// 抽奖活动会场主页面
export const getPlaceInfoApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/draw/mainList`, data, requireToken: true});
// 活动抽奖
export const getDrawTurntableApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/draw/lottery`, data, requireToken: true});
// 中奖记录
export const getTurntableRecordApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/draw/record`, data, requireToken: true});
// 中奖记录游戏列表
export const getGamesListApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/draw/games`, data, requireToken: true});
// 转盘任务
export const getTaskListApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/draw/tasks`, data, requireToken: true});
// 完成任务
export const getCompleteTaskApi= (data) => axios.request({ url: `${getEnv()}/wx-box-game/wheelV2/draw/complete-task`, data, requireToken: true});

// 注册活动-活动信息
export const getRegisterActApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/registerActivity/info`,
    data,
    requireToken: true,
  });

// 注册活动-会场列表
export const getRegisterGamesApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/registerActivity/placeList`,
    data,
    requireToken: true,
  });

// 注册活动-福利列表
export const getRegisterWelfareApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/registerActivity/welfareList`,
    data,
    requireToken: true,
  });

// 注册活动-领取福利
export const drawRegisterWelfareApi = (data) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/registerActivity/draw`,
    data,
    requireToken: true,
    unHint: true,
  });

// ----------------- 注册抽奖 -----------------
// 活动信息
export const getDrawLotteryActApi = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/info`,
    data,
    requireToken: true,
  });
// 会场列表
export const getDrawLotteryGamesApi = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/placeList`,
    data,
    requireToken: true,
  });
// 会场列表V2
export const getDrawLotteryGamesV2Api = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/placeListV2`,
    data,
    requireToken: true,
  });
// 弹窗:推荐游戏列表
export const getRecGamesApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/recommendGameList`,
    data,
    requireToken: true,
  });
// 下载上报
export const reportDownloadRecApi = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/downloadReport`,
    data,
    requireToken: true,
  });

// 会场信息
export const getDrawLotteryGameInfoApi = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/place/info`,
    data,
    requireToken: true,
  });
// 领取
export const drawLotteryReceiveApi = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/place/receive`,
    data,
    requireToken: true,
    unHint: true,
  });
// 抽奖
export const drawLotteryDrawApi = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/place/lottery`,
    data,
    requireToken: true,
    unHint: true,
  });
// 中奖记录
export const drawLotteryRecordApi = (data, isBt = false) =>
  axios.request({
    url: `${getBoxPrefix(isBt)}/registerLottery/recordList`,
    data,
    requireToken: true,
  });

// ----------------- 新注册-pk -----------------
// 活动主页
export const getPkMainInfo = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/newlyRegisterAvtivity/homeList`,
    data,
    requireToken: true,
  });
}

// 加入队伍
export const joinPkTeam = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/newlyRegisterAvtivity/joinTeam`,
    data,
    requireToken: true,
  });
}

// 任务列表
export const getTasksApi = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/newlyRegisterAvtivity/taskList`,
    data,
    requireToken: true,
  });
}

// 完成任务
export const onCompleteTask = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/newlyRegisterAvtivity/completeTask`,
    data,
    requireToken: true,
    unHint: true,
  })
}

// 积分明细
export const getIntegralDetail = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/newlyRegisterAvtivity/taskCreditDetail`,
    data,
    requireToken: true,
  })
}

// 推荐游戏列表
export const getRecommendGames = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/newlyRegisterAvtivity/recommendGameList`,
    data,
    requireToken: true,
  })
}

// 328注册活动首页
export const get328HomePage = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/generalRegActivity/getHomeList`,
    data,
    requireToken: true,
  })
}

// 328注册活动首页
export const get328Gift = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/generalRegActivity/drawReward`,
    data,
    requireToken: true,
    unHint: true,
  })
}

// ----------------- 大富翁活动 -----------------
// 活动信息
export const getZillianMainInfo = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/richManActivity/getHomeList`,
    data,
    requireToken: true,
    unHint: true,
  });
}

// 任务列表
export const getZillianTasks = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/richManActivity/taskList`,
    data,
    requireToken: true,
  });
}

// 完成任务
export const completeZillianTask = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/richManActivity/completeTask`,
    data,
    requireToken: true,
    unHint: true,
  })
}

// 奖励列表
export const getZillianRewards = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/richManActivity/rewardList`,
    data,
    requireToken: true,
  })
}

// 掷骰子
export const rollDiceApi = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/richManActivity/diceStep`,
    data,
    requireToken: true,
  })
}

// 奖励记录
export const getZillianRewardRecord = (data) => {
  return axios.request({
    url: `${getEnv()}/wx-box-active/richManActivity/rewardRecordList`,
    data,
    requireToken: true,
  })
}
